import React from 'react';
import BaseTable from './BaseTable';

const InReview = () => {
  const tableHeaders = [
    "Entered Peer Review",
    "Channel",
    "Author",
    "Title",
    "Reviews",
    "History"
  ]

  const rowNames = [
    "most_recent_activity",
    "channel_name",
    "admin_user_link",
    "title",
    "review_balls",
    "reminder_history"
  ]

  const columnAmountAndWidths = [
    {width: '180px'},
    null,
    {width: '160px'},
    null,
    {width: '100px'},
    {width: '100px', class: 'centered'}
  ]

  return <BaseTable
          tableHeaders={tableHeaders}
          state={"in_review"}
          rowNames={rowNames}
          historyElementColumnIndex={5}
          removeOrderingColumn={[0,5]}
          columnAmountAndWidths={columnAmountAndWidths}
          enableEmailReminder={false}
          emailTemplateName={"InReview"}
          />
}

export default InReview;